import {
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";

const BlogCommentSection = () => {
  return (
    <Stack>
      <Stack
        sx={{
          paddingLeft: "8px",
          paddingRight: "8px",
        }}
      >
        <Stack>
          <Stack
            sx={{
              fontSize: {
                xs: "22px",
                sm: "28px",
                md: "28px",
                lg: "28px",
                xl: "28px",
              },
              lineHeight: {
                xs: "32px",
                sm: "32px",
                md: "40px",
                lg: "40px",
                xl: "40px",
              },
              fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
              color: "black",
              fontFamily:
                "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
              marginBottom: {
                xl: "16px",
                lg: "16px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
            }}
          >
            Leave a Reply{" "}
          </Stack>
          <Stack
            sx={{
              marginBottom: {
                xl: "16px",
                lg: "16px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
            }}
          >
            <span>
              Your email address will not be published. Required fields are
              marked <span style={{ color: "red" }}>*</span>
            </span>
          </Stack>

          <Stack
            sx={{
              marginBottom: {
                xl: "16px",
                lg: "16px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
            }}
          >
            <TextField
              required
              label="Comment"
              multiline
              rows={4}
              variant="outlined"
              fullWidth
            />
          </Stack>

          <Stack
            direction={{
              xs: "column",
              sm: "row",
            }}
            spacing={2}
            sx={{
              marginBottom: {
                xl: "16px",
                lg: "16px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
            }}
          >
            <TextField required label="Name" variant="outlined" fullWidth />
            <TextField
              required
              label="Email"
              type="email"
              variant="outlined"
              fullWidth
            />
          </Stack>

          <Stack
            sx={{
              marginBottom: {
                xl: "16px",
                lg: "16px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
            }}
          >
            <TextField label="Website" variant="outlined" fullWidth />
          </Stack>

          {/* Checkbox */}
          <FormControlLabel
            control={<Checkbox />}
            label="Save my name, emailand website in this browser for the next time I comment."
            sx={{
              marginBottom: {
                xl: "16px",
                lg: "16px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
            }}
          />

          {/* Submit Button */}
          <Button
            variant="contained"
            color="success"
            sx={{
              fontWeight: "bold",
              textTransform: "uppercase",
              maxWidth: 200,
              marginBottom: {
                xl: "16px",
                lg: "16px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
            }}
          >
            Post Comment
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BlogCommentSection;
